module.exports = __webpack_public_path__ + "static/media/synth_11.8b3efad0.mp3";